import { useMutation, useQueryClient } from "@tanstack/react-query";
import { StreamsCategories } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { KEY_PREFIX } from "components/streams/hooks/useStreams";
const useStreamCategoryMutation = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ streamId, categories }) => StreamsCategories.updateStreamCategories(streamId, categories),
    onSuccess: () => {
      UserNotification.success("Stream categories updated successfully.", "Success");
      queryClient.invalidateQueries({ queryKey: KEY_PREFIX });
    },
    onError: (error) => {
      UserNotification.error(`Failed to update stream categories: ${error.message}`);
    }
  });
  return { updateCategories: mutation };
};
export default useStreamCategoryMutation;
